import { merge } from 'lodash';
import { defaultPaginationConfig } from '../../../constants/config-defaults';
export const ensureResponseBelongToResource = ({ response, resourceId, }) => {
    const commentsForResource = response.comments.comments.filter((comment) => comment.resourceId === resourceId);
    if (commentsForResource.length === 0) {
        return { type: 'ERROR' };
    }
    return {
        type: 'SUCCESS',
        response: {
            ...response,
            comments: {
                ...response.comments,
                comments: commentsForResource,
            },
        },
    };
};
export function resolvePagination(partial = {}) {
    return merge({}, defaultPaginationConfig, partial);
}
//# sourceMappingURL=comments-paging-utils.js.map